import { useQuery } from '@tanstack/react-query';
import { shallow } from 'zustand/shallow';
import { useTenantContext } from 'src/context/useTenantContext';
import { tenantDashboardEmployeeIncomes, tenantEmployees } from 'src/services/apis/tenantRequests';
import { useEmployeeStore } from 'src/states/employee';
import { QUERIES } from 'src/utils/react-query';

export const useEmployees = () => {
  const { orgSlug, restaurantId } = useTenantContext();
  return useQuery([QUERIES.EMPLOYEES, orgSlug, restaurantId], () => tenantEmployees({ orgSlug, restaurantId }));
};

export const useEmployeeIncomesDashboard = () => {
  const { orgSlug, restaurantId, branchId } = useTenantContext();
  const { employeeId } = useEmployeeStore(
    (state) => ({
      employeeId: state.employeeId,
    }),
    shallow
  );

  const query = useQuery(
    [
      QUERIES.EMPLOYEE_INCOMES,
      orgSlug,
      restaurantId,
      branchId,
      {
        employeeId,
      },
    ],
    ({ queryKey: [_key, _orgSlug, _restaurantId, _branchId, _filters] }) =>
      tenantDashboardEmployeeIncomes(
        {
          orgSlug: _orgSlug as string,
          restaurantId: _restaurantId as string,
          branchId: _branchId as string,
        },
        _filters as any
      ),
    {
      cacheTime: 0,
      refetchOnMount: true,
      refetchInterval: 120000,
      keepPreviousData: false,
      refetchOnWindowFocus: true,
      enabled: !!employeeId,
    }
  );
  return {
    query,
  };
};
